import React from "react";
import Header from "../Components/Header";
import MainSection from "../Components/MainSection";
import AboutUs from "../Components/AboutUs";
import WhyChooseUs from "./WhyChooseUs";
import Products from "./Products";
import ScoreBoard from "./ScoreBoard"
import Footer from "./Footer";
import Categories from "./Categories";

const Home = () => {
  return (
    <>
      <div>
      <MainSection />
      </div>

     <div style={{margin:'80px 0px'}}>
     <AboutUs />
     </div>

     <div style={{marginBottom:'80px'}}>
     <WhyChooseUs />
     </div>
  
    <div style={{margin:'80px 0px'}}>
    <Products />
    </div>
    
    <div>
    <ScoreBoard/>
    </div>
    
    <div style={{margin:'80px 0px'}}>
    <Categories/>
    </div>
    </>
  );
};

export default Home;
